class CustomConceptViewController extends SingleEditViewController
{    
    static newInstance() : CustomConceptViewController 
    {
        let vc = new CustomConceptViewController("single-edit-view");
        vc.initWithResource("layout/base/SingleEditView.html");
        return vc;
    }

    get title(){
        return MIOLocalizeString("CUSTOM_CONCEPTS", "CUSTOM CONCEPTS");
    }

    fetchEntity(){
        return "CustomConcept";
    }

    sortDescriptors(){
        return [MIOSortDescriptor.sortDescriptorWithKey("concept", true)];
    }

    configureCellAtIndexPath(cell:SingleEditCell, indexPath:MIOIndexPath, item:MIOManagedObject){
        let d = item as Department;
        cell.setItem(d, "concept");
    }

    addButtonDidPress(){

        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("NEW_CUSTOM_CONCEPT", "NEW CUSTOM CONCEPT"), MIOLocalizeString("CHOOSE_A_CONCEPT", "CHOOSE A CONCEPT"), MUIAlertViewStyle.Default);

        avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField){
           textField.setPlaceholderText(MIOLocalizeString("CONCEPT", "CONCEPT"));
        });

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("ADD", "ADD"), MUIAlertActionStyle.Default, this, function(){
            let name = avc.textFields[0].text;
            let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
            let d = MIOEntityDescription.insertNewObjectForEntityForName(this.fetchEntity(), ad.managedObjectContext) as CustomConcept;
            d.concept = name;
            
            ad.managedObjectContext.save();
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));

        this.presentViewController(avc, true);
    }

    removeItem(item:MIOManagedObject){
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        ad.managedObjectContext.deleteObject(item);
        ad.managedObjectContext.save();        
    }
}